import React from 'react';

export const PlayVideoIcon = ({ width = 64, height = 64 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="94" height="94" viewBox="0 0 94 94" fill="none">
        <g filter="url(#filter0_d_122_65)">
            <rect x="15" y="15" width={width} height={height} rx="32" fill="white" />
            <g filter="url(#filter1_d_122_65)">
                <path
                    d="M62 47L39.5 59.9904L39.5 34.0096L62 47Z"
                    fill="url(#paint0_linear_122_65)"
                />
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_122_65"
                x="0"
                y="0"
                width="94"
                height="94"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.145098 0 0 0 0 0.152941 0 0 0 0 0.2 0 0 0 0.18 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_122_65"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_122_65"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_122_65"
                x="29.5"
                y="24.0095"
                width="42.5"
                height="45.981"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_122_65"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_122_65"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_122_65"
                x1="39.5"
                y1="34"
                x2="50.7583"
                y2="53.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#4194F0" />
                <stop offset="1" stopColor="#8BC2F6" />
            </linearGradient>
        </defs>
    </svg>
);
